// extracted by mini-css-extract-plugin
export var arrowUpAndDown = "DropDownMenu-module--arrow-up-and-down--ec942";
export var buttonContainer = "DropDownMenu-module--buttonContainer--c9aec";
export var container = "DropDownMenu-module--container--021d2";
export var contentContainer = "DropDownMenu-module--contentContainer--53a16";
export var entriesContainer = "DropDownMenu-module--entriesContainer--de267";
export var headerWithOpaqueBackground = "DropDownMenu-module--headerWithOpaqueBackground--1a4c6";
export var mobileEntry = "DropDownMenu-module--mobileEntry--a5815";